:host {
  display: block;
}
[hidden] {
  display: none !important;
}

::slotted(*:not(:first-child)) {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

::slotted(ul) {
  line-height: 1.4em;
  list-style-type: disc;
  margin: 0;
  padding: 0;
  padding-left: 20px;
}

.alert {
  font-family: var(--sc-input-font-family);
  font-weight: var(--sc-font-weight-normal);
  font-size: var(--sc-button-font-size-medium);
  line-height: var(--sc-line-height-dense);
  border-radius: var(--sc-alert-border-radius, var(--sc-border-radius-medium));
  padding: var(--sc-spacing-large);
  margin-bottom: var(--sc-spacing-large);
  display: flex;
  align-items: flex-start;
  border: var(--sc-alert-border, var(--sc-input-border));
  border-top: solid var(--sc-alert-border-width, 3px);
  color: var(--sc-alert-color, var(--sc-input-label-color));
  background: var(--sc-alert-background-color, var(--sc-color-white));
  box-shadow: var(--sc-shadow-small);

  &__text {
    flex: 1;
  }

  &.alert--primary {
    border-top-color: var(--sc-alert-primary-border-color, var(--sc-color-primary-500));
    a {
      color: var(--sc-color-primary-900);
    }
    .alert__title {
      color: var(--sc-alert-title-color, var(--sc-color-gray-800));
    }
    .alert__icon {
      color: var(--sc-alert-primary-icon-color, var(--sc-color-primary-500));
    }
  }
  &.alert--info {
    border-top-color: var(--sc-alert-info-border-color, var(--sc-color-info-500));
    a {
      color: var(--sc-color-info-900);
    }
    .alert__title {
      color: var(--sc-alert-title-color, var(--sc-color-gray-800));
    }
    .alert__icon {
      color: var(--sc-alert-info-icon-color, var(--sc-color-info-500));
    }
  }
  &.alert--danger {
    border-top-color: var(--sc-alert-danger-border-color, var(--sc-color-danger-500));
    a {
      color: var(--sc-color-danger-900);
    }
    .alert__title {
      color: var(--sc-alert-title-color, var(--sc-color-gray-800));
    }
    .alert__icon {
      color: var(--sc-alert-danger-icon-color, var(--sc-color-danger-500));
    }
  }
  &.alert--warning {
    border-top-color: var(--sc-alert-warning-border-color, var(--sc-color-warning-500));
    a {
      color: var(--sc-color-warning-900);
    }
    .alert__title {
      color: var(--sc-alert-title-color, var(--sc-color-gray-800));
    }
    .alert__icon {
      color: var(--sc-alert-warning-icon-color, var(--sc-color-warning-500));
    }
  }
  &.alert--success {
    border-top-color: var(--sc-alert-success-border-color, var(--sc-color-success-500));
    a {
      color: var(--sc-color-success-900);
    }
    .alert__title {
      color: var(--sc-alert-title-color, var(--sc-color-gray-800));
    }
    .alert__icon {
      color: var(--sc-alert-success-icon-color, var(--sc-color-success-500));
    }
  }
}

.alert__icon {
  flex: 1;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  font-size: var(--sc-font-size-large);
  padding-inline-end: var(--sc-spacing-medium);
}

.alert__title {
  font-weight: var(--sc-font-weight-semibold);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.alert__close {
  transition: background-color var(--sc-transition-fast) ease;
  display: inline-flex;
  border-radius: var(--sc-border-radius-small);
  padding: var(--sc-spacing-x-small);
  margin-left: auto;
  cursor: pointer;
  svg {
    width: 1em;
    height: 1em;
  }
}

.alert--is-rtl {
  text-align: right;

  &.alert-close {
    margin-right: auto;
    margin-left: unset;
  }

  ::slotted(ul) {
    margin: 0;
    padding: 0;
    padding-right: 20px;
  }
}
